/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-lines */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, createContext, useRef } from 'react';
import uuid from '@utils/uuid';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
import H5 from '@base/H5/H5';
import imageHelper from '@utils/imageHelper';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Normalize } from 'styled-normalize';
import { Provider, useSelector, useDispatch } from 'react-redux';
import withRedux from 'next-redux-wrapper';
import {
  createMuiTheme,
  ThemeProvider as MUIThemeProvider,
  StylesProvider
} from '@material-ui/core/styles';
import nextCookie from 'next-cookies';
import Router from 'next/router';
import Head from 'next/head';
import NProgress from 'nprogress';
import '@utils/sentry'; // sentry initialization
import {
  reauthenticate,
  fetchMyInfo,
  fetchFollowedGoals,
  showFollowGoalTooltip,
  setSelectedGoal,
  showSwitchGoalTooltip,
  setDarkMode,
  fetchAccessControl,
  dailyTaskStatus,
  toggleSiteWideReferralBanner
} from '@actions/auth';
import { setPlayerURL } from '@actions/player';
import cookies from '@utils/cookies';
import { Platform, LearnerId, LearnerUserName } from '@events/eventProps';
import { setupAnalytics } from '@events/sendAnalytics';
import { fetchConstants } from '@actions/others';
import { fetchTopologyInfo } from '@actions/topologies';
import { fetchAnalyticsSchema, sendGAId } from '@actions/analytics';
import {
  getDaysRemainingInSubscription,
  hasActiveSubscriptionToGoal
} from '@models/Me';
import Layout from '@layout/index';
import usePrevious from '@hooks/usePrevious';
import useIntercom from '@hooks/useIntercom';
import useSpeedcurve from '@hooks/useSpeedcurve';
import useFreshBots from '@hooks/useFreshBots';
import useFreshTicket from '@hooks/useFreshTicket';
import useBrowserSupport from '@hooks/useBrowserSupport';
import { fetchNotifications } from '@actions/notifications';
import {
  fetchCashPaymentStatus,
  resetCashResponseData
} from '@actions/checkout';
// import { clearLocalStorage } from '@utils/localStorage';
import { checkShowReferrals } from '@utils/referralHelper';
import deviceHelper from '@utils/deviceHelper';
import { showTTUOption } from '@actions/ttu';
import { CASH_ORDER_STATUS } from '@cont/Checkout/utils';
import { setPageInfo } from '@actions/currentPageInfo';
import { DefaultSeo } from 'next-seo';
import SegmentAnalytics from '@Analytics/Segment';
import Dynamic from '@base/Dynamic/Dynamic';
import { PurchaseTypeContextProvider } from '@context/PurchaseTypeContext';
import loadModule from '@utils/loadModule';
import useEducatorContext from '@hooks/useEducatorContext';
import { authTypes } from '@actions-constants/index';
import parseUrlQuery from '@utils/marketing';
import setPlatform, { setCampaign } from '@actions/helper';
import initStore from '../redux';
import '../global.css';
import '../picker.css';
import getTheme from '../themes';
import SEO from '../../next-seo.config';

NProgress.configure({
  trickleRate: 0.1,
  trickleSpeed: 800,
  showSpinner: false
});
Router.events.on('routeChangeStart', () => {
  NProgress.start();
});
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

const SnackBar = Dynamic(() => import('@comp/SnackBar/SnackBar'));

export const IsEducatorSideContext = createContext(false);

const GlobalStyle = createGlobalStyle`
  html {
    ${({ isOffline }) => isOffline && 'filter: grayscale(100%);'}
  }
  body {
    background-color: ${({ theme }) => theme?.colors?.base};
  }
  #mobile-chat-container {
    box-shadow: ${({ theme }) => boxShadowGenerator({ theme })} !important;
  }
`;

const fullStoryId = process.env.FULLSTORY_ID;

// Uncomment the following code to check re renders.
if (process.env.NODE_ENV === 'development') {
  // if (typeof window !== 'undefined') {
  //   const whyDidYouRender = require('@welldone-software/why-did-you-render');
  //   whyDidYouRender(React, {
  //     onlyLogs: true,
  //     titleColor: 'green',
  //     diffNameColor: 'aqua',
  //     trackAllPureComponents: true,
  //     logOwnerReasons: true,
  //     logOnDifferentValues: true,
  //     trackExtraHooks: [[require('react-redux/lib'), 'useSelector']]
  //   });
  // }
}

const MUITheme = createMuiTheme({
  typography: {
    fontFamily: 'AvertaStd, -apple-system, BlinkMacSystemFont, sans-serif;'
  }
});

// Router.push() reloads the page in dev, but works fine in prod build

const getRedirectionUrl = (pathname, selectedGoal) => {
  const { goalSlug, slug, uid } = selectedGoal;
  const href = '/goal/[goalSlug]/[goalUID]';
  const as = `/goal/${goalSlug || slug}/${uid}`;

  const routes = {
    '/': selectedGoal && { href, as },
    '/index': selectedGoal && { href, as }
  };
  return routes[pathname];
};

const checkIsFollowedGoal = async (ctx) => {
  const followedGoals = ctx.store.getState().auth.followedGoals || [];
  const followedGoalIds = followedGoals.map((item) => item.topology);
  const { goalUID } = ctx.query;
  const show = !!(goalUID && !followedGoalIds.includes(goalUID));
  await ctx.store.dispatch(showFollowGoalTooltip(show));
};

const checkGoalSwitch = async (ctx, currentPageGoalUid, selectedGoalUid) => {
  const isCurrentPageGoalFollowed = ctx.store
    .getState()
    .auth.followedGoals?.find((item) => item.topology === currentPageGoalUid);

  if (
    currentPageGoalUid &&
    selectedGoalUid &&
    currentPageGoalUid !== selectedGoalUid &&
    isCurrentPageGoalFollowed
  ) {
    await ctx.store.dispatch(showSwitchGoalTooltip(true));
  } else {
    await ctx.store.dispatch(showSwitchGoalTooltip(false));
  }
};

const redirect = (isServer, redirectionUrl, ctx) => {
  if (isServer) {
    ctx.res.writeHead(302, { Location: redirectionUrl.as });
    return ctx.res.end();
  }
  return Router.push(redirectionUrl.href, redirectionUrl.as);
};

const setInfoOfPage = ({ Component, pathname, query, store }) => {
  const { pageInfo = { name: '' } } = Component;
  if (typeof pageInfo.name === 'function') {
    pageInfo.name = pageInfo.name({
      router: { pathname, query },
      state: store.getState()
    });
  } else if (!pageInfo.name) pageInfo.name = pathname;
  store.dispatch(
    setPageInfo({
      ...pageInfo,
      route: pathname
    })
  );
};

const handleCashPaymentLogic = (resp, query, store, selectedGoal) => {
  const currentGoalUID = query.goalUID || selectedGoal?.uid;
  const checkCashStatus = resp?.result?.check_cash_payment_status || false;
  if (checkCashStatus && currentGoalUID) {
    store
      .dispatch(fetchCashPaymentStatus(query.comboUID || currentGoalUID))
      .then((response) => {
        if (response?.result) {
          const cashResponse = response.result;
          if (cashResponse?.cash_payment_state === CASH_ORDER_STATUS.PAID) {
            const goalDetails =
              cashResponse.user_subscription_details?.user_subscription
                .subscription.value;
            redirect(false, {
              href: '/goal/[goalSlug]/[goalUID]/subscribe/thank-you',
              as: `${goalDetails.relative_link}/subscribe/thank-you?mode=cash`,
              query: {
                mode: 'cash'
              }
            });
          }
        }
      });
  }
};

const onAppStart = async ({ Component, ctx }) => {
  const { isServer, store, pathname, query, asPath, req } = ctx;
  if (isServer) {
    // eslint-disable-next-line no-console
    console.log(asPath);
  }
  if (asPath === '/health') return;
  const userAgent = isServer ? req.headers['user-agent'] : '';
  store.dispatch(
    setPlatform(
      deviceHelper.isMobile({ isServer, userAgent }),
      deviceHelper.isIos({ isServer, userAgent })
    )
  );
  store.dispatch(setCampaign(parseUrlQuery(query)));
  if (query.in_app === 'true') {
    return;
  }
  if (asPath.length > 1 && asPath.endsWith('/')) {
    let route = pathname;
    const asPathWithoutEndingSlash = asPath.replace(/\/*$/gim, '');
    if (pathname === '/[authorID]' && !asPath.includes('@')) {
      route = asPathWithoutEndingSlash;
    }

    redirect(isServer, { href: route, as: asPathWithoutEndingSlash }, ctx);
    return;
  }

  const localCookies = nextCookie(ctx);

  const { selectedGoalUid, isDarkModeOn } = localCookies;

  if (isServer && selectedGoalUid) {
    await store.dispatch(fetchTopologyInfo(selectedGoalUid));
  }

  let selectedGoal = null;
  selectedGoal = selectedGoalUid
    ? store.getState().topologies.data[selectedGoalUid]
    : null;

  const redirectionUrl = selectedGoal
    ? getRedirectionUrl(pathname, selectedGoal)
    : null;
  const { isMobile } = store.getState().helper;

  if (redirectionUrl?.as && !pathname.includes('classroom') && !isMobile) {
    return redirect(isServer, redirectionUrl, ctx);
  }

  if (!store.getState().others.constants) {
    await store.dispatch(fetchConstants());
  }

  if (isServer) {
    store.dispatch(setDarkMode(!!isDarkModeOn));
    store.dispatch(
      reauthenticate({
        accessToken: localCookies.accessToken,
        refreshToken: localCookies.refreshToken
      })
    );

    if (localCookies.accessToken) {
      const meResp = await ctx.store.dispatch(fetchMyInfo());
      if (meResp?.type === `${authTypes.ME}_SUCCESS`) {
        const followedGoalsResp = await ctx.store.dispatch(
          fetchFollowedGoals()
        );
        if (followedGoalsResp?.type === `${authTypes.FOLLOWED_GOALS}_SUCCESS`) {
          // await checkIsFollowedGoal(ctx, followedGoalsResp);
        }
      }
      ctx.store.dispatch(setSelectedGoal(selectedGoal));
      ctx.store.dispatch(resetCashResponseData());
      const currentGoalUID = query.goalUID || selectedGoal?.uid;
      const resp = await ctx.store.dispatch(fetchAccessControl(currentGoalUID));
      handleCashPaymentLogic(resp, query, store, selectedGoal);
    }
    if ((query.goalUID || selectedGoal?.uid) && !isMobile)
      await ctx.store.dispatch(
        showTTUOption(query.goalUID || selectedGoal?.uid)
      );
  }

  // Follow goal Tooltip check
  await checkIsFollowedGoal(ctx);
  // Switch goal Tooltip check
  await checkGoalSwitch(ctx, query.goalUID, selectedGoalUid);
  // set pageInfo
  setInfoOfPage({ Component, pathname, query, store });
};

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 9999999999;
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
`;

const InternetInfo = styled.div`
  margin: auto;
  position: fixed;
  top: ${({ isVisible }) => (isVisible ? '50px' : '30px')};
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  left: 0;
  right: 0;
  background-color: #333333;
  display: inline-block;
  width: 250px;
  border-radius: 8px;
  text-align: center;
  padding: 16px;
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transition: top 300ms ease-in, opacity 300ms ease-in, visibility 300ms ease-in;
  z-index: 99999999999;
`;

const InternetInfoImg = styled.img`
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 8px;
`;

const InternetInfoText = styled(H5)`
  color: #fff;
`;

const RenderSnackBar = () => {
  const snackBarContent = useSelector(({ others }) => others.snackBarContent);
  return snackBarContent ? (
    <SnackBar
      message={snackBarContent.message}
      time={snackBarContent.time}
      type={snackBarContent.type}
      anchorOrigin={snackBarContent.anchorOrigin}
    />
  ) : null;
};

const RenderIntercom = ({ route }) => {
  const isLoggedIn = useSelector(({ auth }) => auth.isLoggedIn);
  const me = useSelector(({ auth }) => auth.me);
  const isSubscribed = me?.plusSubscriptionUids?.length > 0;
  const isClassModalOpened = useSelector(
    ({ items }) => items.isClassModalOpened
  );
  const dispatch = useDispatch();
  const prevUserId = usePrevious(me?.uid);
  useFreshTicket();
  useIntercom(
    route,
    me?.uid,
    prevUserId,
    isClassModalOpened,
    me,
    isSubscribed,
    dispatch,
    isLoggedIn
  );
  return null;
};

const RenderChatBot = ({ route }) => {
  const isLoggedIn = useSelector(({ auth }) => auth.isLoggedIn);
  const me = useSelector(({ auth }) => auth.me);
  const selectedGoal = useSelector(({ auth }) => auth.selectedGoal);
  const accessToken = useSelector(({ auth }) => auth.accessToken);
  const isSubscribed = me?.plusSubscriptionUids?.length > 0;
  const isClassModalOpened = useSelector(
    ({ items }) => items.isClassModalOpened
  );
  const showFreshbot = isSubscribed;
  const inEducatorSide = useEducatorContext();
  const dispatch = useDispatch();
  useFreshTicket();
  useFreshBots(
    route,
    accessToken,
    showFreshbot,
    dispatch,
    me,
    isLoggedIn,
    inEducatorSide,
    selectedGoal,
    isClassModalOpened
  );

  return null;
};

const RenderJWT = ({ query }) => {
  const me = useSelector(({ auth }) => auth.me);
  const isMobile = useSelector(({ helper }) => helper.isMobile);
  const selectedGoal = useSelector(({ auth }) => auth.selectedGoal);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(toggleSiteWideReferralBanner(checkShowReferrals()));
    if (me?.uid) {
      dispatch(fetchNotifications());
      dispatch(dailyTaskStatus());
      if ((query.goalUID || selectedGoal?.uid) && !isMobile) {
        dispatch(showTTUOption(query.goalUID || selectedGoal?.uid));
      }
      cookies.setCookie('jwtToken', me?.jwtToken, 3024000, true);
    }
  }, [me?.uid]);

  return null;
};

const UNApp = ({ Component, pageProps, store, router }) => {
  const gtagTimeOut = useRef({});
  const {
    me,
    selectedGoal,
    isLoggedIn,
    checkPartPaymentStatus
  } = store.getState().auth;
  const { campaign } = store.getState().helper ?? {};
  const { route, asPath } = router;
  // redirect user to /browser if browser is not compatible
  useBrowserSupport(route);
  const accessToken = cookies.readCookie('accessToken', store.getState);

  const inEducatorSide = useEducatorContext();
  const [isDarkModeOn, toggleDarkMode] = useState(
    store.getState().auth.isDarkModeOn
  );
  const [isWindows, setIsWindows] = useState(false);
  const isSubscribed = me?.plusSubscriptionUids?.length > 0;
  const isMobileDevice = store.getState().helper.isMobile;

  const googleAnalyticsDetails = () => {
    if (me?.uid) store.dispatch(sendGAId(me.username, campaign));
  };

  useEffect(async () => {
    // access_control API call optimisation
    // if part payment status is already true in store then no need to call access_control API on goal change
    // but if required to call access_control API on every goal change in future then can remove the if condition
    const currentGoalUID = router.query.goalUID || selectedGoal?.uid;
    if (isLoggedIn && !checkPartPaymentStatus[currentGoalUID]) {
      store.dispatch(resetCashResponseData());
      const resp = await store.dispatch(fetchAccessControl(currentGoalUID));
      handleCashPaymentLogic(resp, router.query, store, selectedGoal);
    }

    if (currentGoalUID) {
      store.dispatch(showTTUOption(currentGoalUID));
    }
  }, [selectedGoal?.uid, router.query.goalUID]);

  useEffect(() => {
    cookies.deleteSubdomainCookies(); // added temporarily to delete the existing subdomain cookies
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }

    setupAnalytics(me, {
      [Platform]: 'Desktop',
      [LearnerId]: me?.uid,
      [LearnerUserName]: me?.username
    });

    const refreshToken = cookies.readCookie('refreshToken', store.getState);
    if (accessToken) {
      cookies.setCookie('accessToken', accessToken, 3024000, true);
      cookies.setCookie('refreshToken', refreshToken, 3024000, true);
    } else {
      cookies.setCookie('anonymous_session_id', uuid());
    }

    if (navigator?.appVersion?.indexOf('Win') !== -1) {
      setIsWindows(true);
    }

    if (me?.uid && me?.isFullStoryUser && fullStoryId && !isMobileDevice) {
      loadModule(import('@fullstory/browser')).then((fs) => {
        fs.init({ orgId: fullStoryId });
        fs.identify(me?.uid, {
          [Platform]: 'Desktop',
          [LearnerId]: me?.uid,
          [LearnerUserName]: me?.username,
          email: me?.email,
          selectedGoal: selectedGoal?.uid,
          selectedGoalName: selectedGoal?.name,
          subscriptionDuration: getDaysRemainingInSubscription(
            me?.plusSubscriptions,
            selectedGoal?.uid
          )
        });
      });
    }
    store.dispatch(setPlayerURL());
    fetchAnalyticsSchema();

    // Clear LocalStorage for firstTime but save class livesession information
    // clearLocalStorage();

    if (route.includes('/payment/response')) {
      loadModule(import('@utils/gtags')).then(() => {
        googleAnalyticsDetails();
      });
    } else {
      gtagTimeOut.current.gtags = setTimeout(() => {
        loadModule(import('@utils/gtags')).then(() => {
          googleAnalyticsDetails();
        });
      }, 10 * 1000);
    }

    window.isMobile = isMobileDevice;
    return () => {
      if (gtagTimeOut.current.gtags) clearTimeout(gtagTimeOut.current.gtags);
    };
  }, []);

  const shouldDisableDarkMode =
    store.getState().currentPageInfo.layoutOptions?.disableDarkMode || false;

  const shouldApplyDarkMode = () => {
    // pre-subscription goal page check
    if (
      (route === '/goal/[goalSlug]/[goalUID]' &&
        me &&
        !hasActiveSubscriptionToGoal(me, router.query.goalUID)) ||
      route.includes('/quiz/')
    ) {
      return false;
    }
    return (
      isDarkModeOn &&
      !shouldDisableDarkMode &&
      !inEducatorSide &&
      !isMobileDevice
    );
  };

  const [isOffline, setIsOffline] = useState(false);
  useEffect(() => {
    const onOnline = () => {
      setIsOffline(false);
    };
    const onOffline = () => {
      setIsOffline(true);
    };
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    window.onerror = () => {
      return false;
    };
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  // Page Viewes
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'pageviewd' });
  }, [asPath]);

  // React GA
  useEffect(() => {
    loadModule(import('react-ga')).then((res) => {
      const ReactGA = res.default;
      if (!window.GA_INITIALIZED) {
        window.GA_INITIALIZED = true;
        ReactGA.initialize(process.env.GOOGLE_ANALYTICS_ID);
      }
      ReactGA.set({ page: window.location.pathname });
      ReactGA.pageview(window.location.pathname);
    });
  }, []);

  // SpeedCurve
  useSpeedcurve(route);

  // Webengage
  useEffect(() => {
    if (isLoggedIn) {
      loadModule(import('@utils/webengage')).then(() => {
        if (window.webengage) {
          window.webengage.init(process.env.WEBENGAGE_KEY);
          window.webengage.user.login(me?.uid);
          window.webengage.user.setAttribute('we_email', me?.email);
          window.webengage.user.setAttribute('platform', 'Desktop');
          window.webengage.user.setAttribute('Learner Username', me.username);
        }
      });
      if (me?.uid) {
        window?.analytics?.identify(me?.uid, {
          name: me.username,
          email: me?.email,
          userId: me?.uid
        });
      }
    }
  }, [isLoggedIn]);

  const DefaultLayout = Component.Layout || Layout;
  const isDarkMode = shouldApplyDarkMode();

  return (
    <Provider store={store}>
      <ThemeProvider theme={getTheme(isDarkMode)}>
        <Normalize />
        <StylesProvider injectFirst>
          <MUIThemeProvider theme={MUITheme}>
            <PurchaseTypeContextProvider
              goalUID={router.query.goalUID || selectedGoal?.uid}
            >
              <IsEducatorSideContext.Provider value={inEducatorSide}>
                <DefaultLayout
                  hasSubscribedGolas={isSubscribed}
                  toggleDarkMode={toggleDarkMode}
                  isDarkModeOn={isDarkMode}
                  isEducatorSide={inEducatorSide}
                >
                  <Head>
                    <meta
                      name="viewport"
                      content="width=device-width, initial-scale=1, shrink-to-fit=no, maximum-scale=1.0, user-scalable=no"
                    />
                    <link
                      key="canonical"
                      rel="canonical"
                      href={`${process.env.DOMAIN}${asPath}`}
                    />
                  </Head>
                  <RenderIntercom route={route} />
                  <RenderChatBot route={route} asPath={asPath} />
                  <RenderJWT query={router.query} />
                  <DefaultSeo {...SEO} />
                  <Component {...pageProps} />
                  {isWindows ? (
                    <link
                      href="//static.uacdn.net/prod/winscroll.css"
                      rel="stylesheet"
                    />
                  ) : null}
                  <SegmentAnalytics />
                  <RenderSnackBar />
                </DefaultLayout>
              </IsEducatorSideContext.Provider>
            </PurchaseTypeContextProvider>
            {isMobileDevice ? null : (
              <>
                <Overlay isVisible={isOffline} />
                <InternetInfo isVisible={isOffline}>
                  <InternetInfoText>
                    <InternetInfoImg
                      src={imageHelper.getImage('checkout/warning.png')}
                      alt="warning"
                      width="20px"
                      height="20px"
                    />
                    No internet connection
                  </InternetInfoText>
                </InternetInfo>
              </>
            )}
          </MUIThemeProvider>
        </StylesProvider>
        <GlobalStyle isOffline={isOffline} />
      </ThemeProvider>
    </Provider>
  );
};

UNApp.getInitialProps = async (appCtx) => {
  await onAppStart(appCtx);
  const { Component, ctx } = appCtx;
  return {
    pageProps: Component.getInitialProps
      ? await Component.getInitialProps(ctx)
      : {}
  };
};

export default withRedux(initStore)(UNApp);
